import { SettingCollectionPath } from '@typings/collections.enum';
import fire from '@store/firebase';
import { deleteImgStorage, saveAndGetImgURL } from '@store/firebase/storage';
import { ISoundEffect } from '@typings/setting/soundEffect.interface';

type Props = {
  data: ISoundEffect;
  buttonSoundFile?: File | null;
  cardSoundFile?: File | null;
  listSoundFile?: File | null;
};

const firestore = fire.firestore();
const settingMusicEffectRef = firestore.doc(SettingCollectionPath.SOUNDEFFECT);

export async function updateSoundEffect({
  data,
  buttonSoundFile,
  cardSoundFile,
  listSoundFile,
}: Props) {
  let buttonSoundURL: string = '';
  let cardSoundURL: string = '';
  let listSoundURL: string = '';

  if (buttonSoundFile) {
    buttonSoundURL = await saveAndGetImgURL('soundEffect', buttonSoundFile);
  }
  if (cardSoundFile) {
    cardSoundURL = await saveAndGetImgURL('soundEffect', cardSoundFile);
  }
  if (listSoundFile) {
    listSoundURL = await saveAndGetImgURL('soundEffect', listSoundFile);
  }
  const newData: ISoundEffect = {
    ...data,
    buttonSound: {
      name: buttonSoundFile?.name || '',
      url: buttonSoundURL,
    },
    cardSound: {
      name: cardSoundFile?.name || '',
      url: cardSoundURL,
    },
    listSound: {
      name: listSoundFile?.name || '',
      url: listSoundURL,
    },
  };
  settingMusicEffectRef;
}

type ISoundSaveProps = {
  key: string;
  file?: File | null;
  prevURL?: string;
  collectionPath?: string;
  docID?: string;
};
export async function updateSoundFile({
  key,
  file,
  prevURL,
  collectionPath,
  docID,
}: ISoundSaveProps) {
  console.log('🔊 updateSoundFile 함수 시작:', {
    key,
    file: file ? { name: file.name, size: file.size } : null,
    prevURL,
    collectionPath,
    docID,
  });

  const _collectionPath = collectionPath
    ? `${collectionPath}/${docID}`
    : SettingCollectionPath.SOUNDEFFECT;

  console.log('📁 최종 collectionPath:', _collectionPath);

  const ref = firestore.doc(_collectionPath);

  let soundURL = '';
  if (prevURL) {
    console.log('🗑️ 이전 파일 삭제:', prevURL);
    deleteImgStorage(prevURL);
  }

  if (file) {
    console.log('📤 파일 업로드 시작...');
    try {
      soundURL = await saveAndGetImgURL(_collectionPath, file, true);
      console.log('✅ 파일 업로드 성공:', soundURL);
    } catch (error) {
      console.error('❌ 파일 업로드 실패:', error);
      throw error;
    }
  }

  console.log('💾 Firestore 저장 시작...');
  try {
    const result = await ref.set(
      {
        [key]: {
          name: file?.name || '',
          url: soundURL,
        },
      },
      { merge: true },
    );
    console.log('✅ Firestore 저장 성공');
    return result;
  } catch (error) {
    console.error('❌ Firestore 저장 실패:', error);
    throw error;
  }
}

export async function removeSoundFile({
  key,
  prevURL,
  collectionPath,
  docID,
}: ISoundSaveProps) {
  const _collectionPath = collectionPath
    ? `${collectionPath}/${docID}`
    : SettingCollectionPath.SOUNDEFFECT;
  const ref = firestore.doc(_collectionPath);

  if (prevURL) deleteImgStorage(prevURL);

  return ref.set({ [key]: { name: '', url: '' } }, { merge: true });
}
